import { render, staticRenderFns } from "./SitchOrderItem.vue?vue&type=template&id=30d4b0f2&scoped=true&"
import script from "./SitchOrderItem.vue?vue&type=script&lang=ts&"
export * from "./SitchOrderItem.vue?vue&type=script&lang=ts&"
import style0 from "./SitchOrderItem.vue?vue&type=style&index=0&id=30d4b0f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d4b0f2",
  null
  
)

export default component.exports